import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectLocale } from "../../../locales/localeSlice";
import SectionTitle from "../General/SectionTitle";
import ServiceBubble from "../General/ServiceBubble/ServiceBubble";
import ServiceLeft from "./ServiceLeft";
import ServiceRight from "./ServiceRight";
import { ServiceContainer, ServiceDividerContainer } from "./Services.styles";

const Services = () => {
  const { t } = useTranslation();
  const currentLocale = useSelector(selectLocale);
  return (
    <ServiceContainer>
      <ServiceBubble
        position="center"
        label={t("servicesSection.keyFeatures", { lng: currentLocale })}
        backgroundColor="rgba(0, 199, 3, 0.1)"
      />
      <SectionTitle
        label={t("servicesSection.ourServices", { lng: currentLocale })}
      />
      <ServiceDividerContainer>
        <ServiceLeft />
        <ServiceRight />
      </ServiceDividerContainer>
    </ServiceContainer>
  );
};

export default Services;
